/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idUnidade: string | null;
  idsSerie: string[];
  idLeadCorretor: any;
  idOportunidade?: any;
}

export function useZerarPV(props: Props) {
  const postData = async () => {
    const ZERAR_PV = `${backofficeEnviroment}/common/oportunidades-lead/zerar-pv/v1`;
    const { data } = await instance.put(ZERAR_PV, {
      idUnidade: props.idUnidade,
      idsSerie: props.idsSerie,
      idLeadCorretor: props.idLeadCorretor,
      idOportunidade: props.idOportunidade,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("PV Zerado com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao zerar PV. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
